import script from "./StoriesMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./StoriesMenu.vue?vue&type=script&lang=ts&setup=true"

import "./StoriesMenu.vue?vue&type=style&index=0&id=4c457c49&lang=css"

const __exports__ = script;

export default __exports__